import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Hero from './sections/Hero';
import Quote from './sections/Quote';
import Services from './sections/Services';
import Pricing from './sections/Pricing';
import Team from './sections/Team';
import AllFeatures from './sections/AllFeatures';
import FeaturesStack from './sections/FeaturesStack';

import CTA from './sections/CTA';
// WaitlistModal is now provided globally by App

export default function LandingPage(){
  const location = useLocation();
  const navigate = useNavigate();

  // If navigation provided a scroll target via location.state.scrollToId,
  // scroll to it synchronously before the first paint to avoid showing
  // the previous route's scroll position briefly.
  useLayoutEffect(()=>{
    const target = location?.state?.scrollToId;
    if(!target) return;
    const el = document.getElementById(target);
    if(el){
      el.scrollIntoView({behavior:'auto', block:'start'});
    }
    // clear the state so repeated renders don't re-trigger
    try{ navigate(location.pathname, { replace:true, state: null }); }catch(e){}
  }, []);

  useEffect(()=>{
    // --- Original page script adapted to run inside React ---
    const hues = {
      purple: [265, 235],    // deep purple
      indigo: [250, 230],    // indigo
      violet: [272, 245],    // violet
      blue:   [235, 215],    // cooler blue (no green)
    };

    let rafId = null;
    let h1Curr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bg-h1'))||265;
    let h2Curr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bg-h2'))||235;
    function shortest(from, to){
      let d = ((to - from + 540) % 360) - 180; // range [-180,180)
      return from + d;
    }
    function tweenTo(targetH1, targetH2, duration=900){
      cancelAnimationFrame(rafId);
      const start = performance.now();
      const fromH1 = h1Curr; const fromH2 = h2Curr;
      const toH1 = shortest(fromH1, targetH1); const toH2 = shortest(fromH2, targetH2);
      function step(now){
        const t = Math.min(1, (now - start)/duration);
        const ease = t<.5 ? 2*t*t : -1+(4-2*t)*t; // easeInOutQuad
        const h1 = fromH1 + (toH1 - fromH1)*ease;
        const h2 = fromH2 + (toH2 - fromH2)*ease;
        document.documentElement.style.setProperty('--bg-h1', h1.toFixed(2));
        document.documentElement.style.setProperty('--bg-h2', h2.toFixed(2));
        if(t < 1){ rafId = requestAnimationFrame(step); } else { h1Curr = targetH1; h2Curr = targetH2; }
      }
      rafId = requestAnimationFrame(step);
    }

    const io = new IntersectionObserver(entries=>{
      entries.forEach(e=>{
        if(e.isIntersecting){
          const k = e.target.dataset.bg; if(!k) return; const [h1,h2]=hues[k]||hues.purple;
          if(Math.abs(h1 - h1Curr) > 0.5 || Math.abs(h2 - h2Curr) > 0.5){ tweenTo(h1, h2, 900); }
        }
      });
    }, {root:null, threshold:0.55, rootMargin: "-10% 0px -35% 0px"});
    document.querySelectorAll('[data-bg]').forEach(sec=>io.observe(sec));

    // Modal controls moved to global component `components/WaitlistModal`.
    // LandingPage no longer attaches modal open/close handlers here.

    // Pricing toggle logic
    const monthlyBtn = document.getElementById('bill-monthly');
    const yearlyBtn = document.getElementById('bill-yearly');
    function setBilling(mode){
      if(!monthlyBtn || !yearlyBtn) return;
      const yearly = mode === 'yearly';
      monthlyBtn.classList.toggle('active', !yearly);
      yearlyBtn.classList.toggle('active', yearly);
      document.querySelectorAll('.price-amount').forEach(el=>{
        const val = yearly ? el.getAttribute('data-year') : el.getAttribute('data-month');
        if(val) el.textContent = val;
      });
      document.querySelectorAll('.price-period').forEach(el=>{ el.textContent = yearly ? '/yr' : '/mo'; });
    }
    monthlyBtn?.addEventListener('click', ()=> setBilling('monthly'));
    yearlyBtn?.addEventListener('click', ()=> setBilling('yearly'));
    setBilling('monthly');

    return ()=>{
      // cleanup
      // Note: modal cleanup moved to components/WaitlistModal
      io && io.disconnect();
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      {/* Hero (includes stars & scroll-blur) */}
      <Hero />

      <div className="section-line" />

      {/* Quote */}
      <Quote />

      {/* Services */}
      {/* <Services /> */}

      {/* Features (moved to its own file) */}
      {/* <AllFeatures /> */}

      <FeaturesStack />


      {/* Pricing */}
      <Pricing />

      {/* Team */}
      {/* <Team /> */}

      {/* CTA Section (moved to its own file) */}
      <CTA />

      {/* Waitlist Modal (rendered from components so it's reusable site-wide) */}
      {/* modal provided globally by App */}
    </>
  );
}
